<template>
  <div class="d-flex justify-center align-center flex-column" :style="{ padding: '10px' }">
    <InformationAlert />
    <v-card
      class="d-flex pa-2 flex-column align-center justify-center"
      outlined
      :style="{
        'margin-bottom': '40px',
        width: '80%',
        'min-height': '550px',
        height: 'fit-content',
      }"
      elevation="2"
    >
      <h3 class="ma-2 text-center">Bulk Upload - Insert Transaction On Us</h3>
      <div
        class="d-flex flex-row justify-center align-center flex-wrap"
        :style="{
          'text-align': 'center',
          width: '85%',
          padding: '50px 0px 50px 0px',
        }"
      >
        <div
          class="d-flex flex-column justify-center align-center"
          style="flex: 1"
        >
          <v-row align="center" class="ma-1" style="width: 60%">
            <v-file-input
              label="Data Transaction (.xlsx)"
              placeholder="Select your files"
              :accept="validate.file_bulk_merchant.type.join()"
              persistent-hint
              outlined
              prepend-inner-icon="mdi-paperclip"
              prepend-icon=""
              v-model="fileBulkMerchant"
              @click="clearLastResult()"
              @focus="fileBulkMerchantFocus += 1"
              :error-messages="fileBulkMerchantErrors"
              @change="$v.fileBulkMerchant.$touch()"
              @blur="$v.fileBulkMerchant.$touch()"
            />
          </v-row>

          <v-row v-if="loading" style="width: 60%" class="mb-5">
            <h4>Generating download file..</h4>
            <v-progress-linear :indeterminate="loading" />
          </v-row>
          <v-row
            class="d-flex flex-column justify-center mb-5"
            v-if="hasFailedImport"
            style="width: 60%"
          >
            <v-card
              class="d-flex flex-column text-left pa-5"
              style="font-size: 13px"
            >
              <h3>Last result :</h3>
              <div style="color: green">
                {{ countSuccess }} record berhasil !
              </div>
              <div style="color: red; margin-bottom: 10px">
                {{ countFailed }} record gagal !
              </div>
              <div class="text--primary">
                Klik
                <a
                  v-if="!loadingDownloadFailed"
                  @click="downloadFailed"
                  @keydown.enter="downloadFailed"
                  >Download</a
                >
                <span v-else>Downloading...</span>
                untuk mengunduh data yang gagal kedalam file .xls
              </div>
            </v-card>
          </v-row>
          <v-row class="mb-1">
            <v-btn
              small
              :loading="loadingDownloadTemplate"
              :disabled="loadingDownloadTemplate"
              @click="downloadBaseTemplate"
            >
              Download Template
            </v-btn>
          </v-row>
          <v-row align="center" class="mb-4 mt-2">
            <v-btn
              small
              color="success"
              :disabled="onUpload || onInsert || isUploadDisabled"
              @click="openDialogConfirm"
              :style="{ margin: '5px' }"
            >
              Upload
              <v-icon right dark> mdi-cloud-upload </v-icon>
            </v-btn>
          </v-row>
        </div>
      </div>

      <template>
        <p class="text-justify text-caption">
          Note:<br />
          Maximum 10.000 rows to insert transaction data.<br/>
          Maximum file size must be 5 MB.
        </p>
      </template>
    </v-card>
    
    <v-dialog v-model="showProgressBar" persistent max-width="500">
      <div style="width: 100%; height: 10px; background-color: #146b76"></div> 
      <v-card class="d-flex flex-column align-center pa-4">
        <v-card-title class="text-h6 text-center">{{ progressTitle }}</v-card-title>

        <v-card-text class="d-flex flex-column align-center pa-4">
          <v-progress-linear :value="percentage" :color="progressColor" height="15" class="mb-3 rounded-xl " style="width: 100%"/>
          <div class="text-center">
            <strong>{{ Math.ceil(percentage) }}%</strong>
          </div>

          <v-row class="justify-center mt-10" style="width: 100%">
            <v-col cols="6" class="d-flex justify-center">
              <v-btn min-width="100%" @click="closeProgressBar" :disabled="disabledProgress">OK</v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-center">
              <v-btn min-width="100%" color="primary" @click="goToHistory" :disabled="disabledProgress">Go to History Request</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirm" width="600" persistent>
      <div style="width: 100%; height: 10px; background-color: #146b76"></div> 
      <confirm-dialog
        :title="'Multiple Request Insert Transaction On Us?'"
        :caution="'Apakah Anda yakin akan mengajukan multiple Request Insert Transaction On Us?'"
        :confirmationText="'Request Insert Transaction On us'"
        v-on:closeCancelParent="close"
        v-on:confirmParent="upload"
      />
    </v-dialog>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { date } from '../../lib/helpers';
import { validations } from '../../store/params';

export default {
  components: {
    confirmDialog: () => import('../../components/ConfirmDialog.vue'),
    InformationAlert: () => import('../../components/insert-transaction/InformationAlert.vue'),
  },
  mixins: [validationMixin],
  validations: {
    fileBulkMerchant: {
      required() {
        if (this.fileBulkMerchantFocus > 1) {
          return this.fileBulkMerchant != null;
        }

        return true;
      },
      fileType() {
        if (this.fileBulkMerchant != null) {
          return !!validations.file_bulk_merchant.type.includes(
            this.fileBulkMerchant.type.toLowerCase()
          );
        }

        return true;
      },
      fileSize() {
        if (this.fileBulkMerchant != null) {

          return this.fileBulkMerchant.size <= 5 * 1024 * 1024;
        }

        return true;
      }
    },
  },
  mounted() {
    this.$store.commit('insertTransactionOnUs/clearLastResult');
  },
  data() {
    return {
      validate: validations,
      fileBulkMerchant: null,
      loadingDownloadTemplate: false,
      loadingDownloadFailed: false,
      fileBulkMerchantFocus: 0,
      searchMerchant: '',
      loadingDownloadFile: false,
      dialogConfirm: false,
    };
  },

  computed: {
    isUploadDisabled() {
      return this.fileBulkMerchantErrors.length > 0;
    },

    disabledProgress() {
      if (this.percentage < 100 && this.failedResponse === false) {
        return true;
      }

      return false;
    },
    loading() {
      return this.$store.state.insertTransactionOnUs.loading;
    },
    uploadProgress() {
      return this.$store.state.insertTransactionOnUs.uploadProgress;
    },
    onUpload() {
      return this.$store.state.insertTransactionOnUs.onUpload;
    },
    insertProgress() {
      return this.$store.state.insertTransactionOnUs.insertProgress;
    },
    insertName() {
      return this.$store.state.insertTransactionOnUs.insertName;
    },
    onInsert() {
      return this.$store.state.insertTransactionOnUs.onInsert;
    },
    countSuccess() {
      return this.$store.state.insertTransactionOnUs.countSuccess;
    },
    countFailed() {
      return this.$store.state.insertTransactionOnUs.countFailed;
    },
    hasFailedImport() {
      return this.$store.state.insertTransactionOnUs.hasFailedImport;
    },
    fileBulkMerchantErrors() {
      const errors = [];

      if (!this.$v.fileBulkMerchant.$dirty) return errors;
      if (!this.$v.fileBulkMerchant.required)
        errors.push('File Data Transaction is required for upload');
      if (!this.$v.fileBulkMerchant.fileType)
        errors.push('Incorrect filetype Data Transaction File');

      if (!this.$v.fileBulkMerchant.fileSize)
        errors.push('Error file! Maximum file size must be 5 MB');


      return errors;
    },
    percentage() {
      return this.$store.state.insertTransactionOnUs.percentage;
    },
    showProgressBar() {
      return this.$store.state.insertTransactionOnUs.showProgressBar;
    },
    progressTitle() {
      return this.$store.state.insertTransactionOnUs.progressTitle;
    },
    progressColor() {
      return this.$store.state.insertTransactionOnUs.progressColor;
    },
    failedResponse() {
      return this.$store.state.insertTransactionOnUs.isFailedResponse;
    },
  },
  methods: {
    goToHistory() {
      this.$router.push('/insert-transaction/history-insert-transaction');
    },
    closeProgressBar() {
      this.$store.dispatch('insertTransactionOnUs/closeProgressBar');
    },
    clearDownloadFailedURL() {
      this.$store.dispatch('insertTransactionOnUs/clearDownloadFailedURL');
    },
    async downloadFailed() {
      this.loadingDownloadFailed = true;
      try {
        const response = await this.$store.dispatch(
          'insertTransactionOnUs/downloadFailedImport'
        );
        if (response) {
          const blob = new Blob([response.data]);
          const fileUrl = URL.createObjectURL(blob);
          const contentDisposition =
            response.headers['content-disposition'] || '';
          const fileNameMatch = contentDisposition.match(
            /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
          );
          const fileName = fileNameMatch
            ? decodeURIComponent(fileNameMatch[1])
            : 'failed-import-transaction-on-us.xlsx';
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl);
        }
      } finally {
        this.loadingDownloadFailed = false;
      }
    },
    async downloadBaseTemplate() {
      this.loadingDownloadTemplate = true;
      try {
        const response = await this.$store.dispatch(
          'insertTransactionOnUs/downloadTemplate'
        );
        if (response) {
          const blob = new Blob([response.data]);
          const fileUrl = URL.createObjectURL(blob);
          const contentDisposition =
            response.headers['content-disposition'] || '';
          const fileNameMatch = contentDisposition.match(
            /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i
          );
          const fileName = fileNameMatch
            ? decodeURIComponent(fileNameMatch[1])
            : 'template-insert-transaction-on-us.xlsx';
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(fileUrl);
        }
      } finally {
        this.loadingDownloadTemplate = false;
      }
    },

    openDialogConfirm() {
      this.$store.commit('insertTransactionOnUs/setClearProgress');
      this.dialogConfirm = true;
      
    },

    close() {
      this.dialogConfirm = false;
    },

    upload() {
      this.dialogConfirm = false;
      this.$store.commit('insertTransactionOnUs/clearLastResult');
      this.fileBulkMerchantFocus = 2;
      this.$v.fileBulkMerchant.$touch();
      if (!this.$v.fileBulkMerchant.$error) {
        this.$store.dispatch('insertTransactionOnUs/bulkUpload', {
          file: this.fileBulkMerchant,
          date,
        });
      }
    },
    clearLastResult() {
      this.$store.commit('insertTransactionOnUs/clearLastResult');
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeProgressBar();
    this.clearDownloadFailedURL();
    this.$store.commit('insertTransactionOnUs/setClearProgress');
    next();
  },
};
</script>

<style scoped>
.v-application p {
    margin-bottom: 8px;
}
</style>
